import axios from 'axios'

const baseURL = '/api/city/'

export default class City {
	/** @constructor
	 * @param {number | Object} init
	 * @property {string} name
	 * @property {number} country_id
	 * @property {number} region_id
	 */
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return

		this.id = init.hasOwnProperty('id') ? init.id : null
		this.name = init.hasOwnProperty('name') ? init.name : ''
		this.country_id = init.hasOwnProperty('country_id') ? init.country_id : null
		this.region_id = init.hasOwnProperty('region_id') ? init.region_id : null
	}

	static url = baseURL

	/**
	 * get all city
	 * @param {Object} params
	 * @returns {Promise<{data: City[]}>}
	 */
	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new City(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	/**
	 * get city by id
	 * @returns {Promise<void>}
	 */
	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/City.class.js